import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

const FETCH_STORE_DETAILS_QUERY_KEY = 'fetch-store-details-query-key';

/**
 * React Query hook for fetching store details.
 */
export const useStoreDetailsQuery = (storeId: string) => {
  const { data, isError, error, isPending, refetch, isFetching } =
    useQueryWithUserId({
      queryKey: [FETCH_STORE_DETAILS_QUERY_KEY, storeId],
      queryFn: () => BIDS_API.fetchStoreDetails(storeId),
      enabled: !!storeId,
      retry: false,
    });

  return {
    error,
    isError,
    data,
    isPending,
    isFetching,
    refetch,
  };
};
